import React from 'react';
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import MainRouter from './router/MainRouter';
import BootstrapManager from './components/BootstrapManager';
import { IntlProvider } from 'react-intl';
import localization from './localization';
import socketContext, { socket } from './context/SocketContext';
import store from './store';
import { Provider } from 'react-redux';

const language = 'cs';

function App () {
  return (
    <IntlProvider messages={localization[language]} locale={language} defaultLocale={language}>
      <Provider store={store}>
        <socketContext.Provider value={socket}>
          <Router>
            <BootstrapManager>
              <MainRouter />
            </BootstrapManager>
          </Router>
        </socketContext.Provider>
      </Provider>
    </IntlProvider>
  );
}

export default App;
